import axiosClient from './axiosClient';

export default {
  // Ricerca paginata con filtri
  getconsenso: () => {
    return axiosClient.get('/consenso/ultimaversione');
  },
};